<template>
  <section class="hero is-fullheight">
    <div class="hero-head">
      <p class="title">{{ $t('page_title') }}</p>
    </div>
    <div class="hero-body">
      <div class="container is-widescreen">
        <div class="colums is-widescreen">
          <!-- Send Emaiil -->
          <div
            class="colum colum-box is-radiusless"
            :class="{'is-active': sendEmailActive,'disabled':disabledEmail}"
          >
            <div @click="clickSendEmail">
              <div class="icon">
                <img src="@/assets/image/ico_m_send_email@2x.png" />
              </div>
              <p class="head-title">{{ $t('title_sendemail') }}</p>
              <i class="drop-down-image is-pulled-right" :class="{'expand': !sendEmailActive}"></i>
            </div>
            <div :class="{'is-hidden': step != 'inputMail' || !sendEmailActive}">
              <div class="content-text">
                <p>{{ $t('description_sendemail') }}</p>
              </div>
              <div class="input-box">
                <input
                  class="input is-radiusless input-filed"
                  :class="{'error': !emailValidation}"
                  type="text"
                  @input="inputSendEmailField"
                  v-model="email"
                  :placeholder="$t('email_placeholder')"
                />
              </div>

              <p
                class="error-message"
                :class="{'is-invisible': emailValidation}"
              >{{ $t('email_format_incorrect') }}</p>
              <div class="btn-box has-text-centered">
                <button
                  class="button btn-red is-radiusless"
                  :disabled="(sendEmailAction || !emailValidation)"
                  @click="send"
                >{{ $t('email_send_button') }}</button>
              </div>
            </div>
            <div class="send-email-content-box" :class="{'is-hidden': step != 'sentMail' }">
              <span class="send-email-title">{{ $t('title_message_sent') }}</span>
              <!-- <div class="media info-box">
                <div class="media-left">
                  <figure class="image is-16x16">
                    <img src="@/assets/image/ico_tip_info@2x.png" />
                  </figure>
                </div>
                <div class="content">
                  <p class="expire-info">{{ $t('email_link_expiration_hint') }}</p>
                </div>
              </div>-->
              <div class="content">
                <p class="send-email-content">{{ Email }}</p>
              </div>
            </div>
          </div>
          <!-- Copy Link -->
          <div
            class="colum colum-box is-radiusless"
            :class="{'is-active': copyLinkActive,'disabled':disabledCopied}"
          >
            <div @click="clickCopyLink">
              <div class="icon">
                <img src="@/assets/image/ico_m_copy_link@2x.png" />
              </div>
              <p class="head-title">{{ $t('title_copylink') }}</p>
              <i class="drop-down-image is-pulled-right" :class="{'expand': !copyLinkActive}"></i>
            </div>
            <div :class="{'is-hidden': !copyLinkActive}">
              <div class="content-text">
                <p>{{ $t('description_copylink') }}</p>
              </div>
              <div class="copy-box">
                <p class="copy-link-text copy-link">{{downloadLink_copy}}</p>
              </div>
              <div class="copy-btn-box has-text-centered">
                <button
                  class="button btn-red is-radiusless"
                  v-clipboard:copy="downloadLink_copy"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >{{ $t('copylink_button') }}</button>
              </div>
              <!-- <div class="media copy-info-box" :class="{ 'is-active':copyMsgStatus }">
                <div class="media-left">
                  <figure class="image is-16x16">
                    <img src="@/assets/image/ico_tip_info@2x.png" />
                  </figure>
                </div>
                <div class="content">
                  <p class="expire-info">{{ $t('share_link_expiration_hint') }}</p>
                </div>
              </div>-->
            </div>
          </div>
          <!-- Scan QR Code -->
          <div
            class="colum colum-box is-radiusless qrocde"
            :class="{'is-active': qrCodeActive,'disabled':disabledQRCode}"
          >
            <div @click="clickQrCode">
              <div class="icon">
                <img src="@/assets/image/ico_m_qr_code@2x.png" />
              </div>
              <p class="head-title">{{ $t('title_scan_qr_code') }}</p>
              <i class="drop-down-image is-pulled-right" :class="{'expand': !qrCodeActive}"></i>
            </div>
            <div :class="{'is-hidden': !qrCodeActive}">
              <div class="content-text">
                <p>{{ $t('description_qrcode') }}</p>
              </div>
              <!-- <div class="media qr-code-info-box">
                <div class="media-left">
                  <figure class="image is-16x16">
                    <img src="@/assets/image/ico_tip_info@2x.png" />
                  </figure>
                </div>
                <div class="content">
                  <p class="expire-info">{{ $t('share_link_expiration_hint') }}</p>
                </div>
              </div>-->
              <div class="qr-code-box">
                <canvas id="qr_code" class="qr-code" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="alarm-message" :class="{ 'is-active':copyMsgStatus }">{{ $t('link_copied_toast') }}</p>
    <p class="captcha-alarm-message" :class="{ 'is-active':errorMsgStatus }">{{ $t('error_toast') }}</p>
    <vue-programmatic-invisible-google-recaptcha
      ref="invisibleRecaptcha"
      :sitekey="'6Ley67AUAAAAAHeDK48aPfM0mQqjsSSc6CrXNMCO'"
      :elementId="'invisibleRecaptcha'"
      :badgePosition="'right'"
      :showBadgeMobile="true"
      :showBadgeDesktop="true"
      @recaptcha-callback="recaptchaCallback"
    ></vue-programmatic-invisible-google-recaptcha>
  </section>
</template>

<script>
import QRCode from "qrcode";
import i18n from "@/i18n";
import store from "@/store";
import axios from "axios";
import { SEND_EMAIL } from "@/constant/urlConfig";
import { EMAIL_REGEX } from "@/constant/regx";
export default {
  name: "Mobile_PAD",
  data() {
    return {
      sendEmailActive: false,
      copyLinkActive: false,
      qrCodeActive: false,
      copyMsgStatus: false,
      errorMsgStatus: false,
      emailValidation: true,
      step: "",
      email: "",
      disabledEmail: false,
      disabledCopied: false,
      disabledQRCode: false,
      sendEmailAction: true,
      language: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("getDownloadLink", {
        encData: encodeURIComponent(to.query.enc_data),
        pid: to.query.pid,
        timestamp: to.query.ver
      })
      .then(
        response => {
          i18n.locale = response;
          next(vm => {
            document
              .getElementsByTagName("html")[0]
              .setAttribute("lang", response);
          });
        },
        error => {
          next(vm => {
            vm.disabledEmail = true;
            vm.disabledCopied = true;
            vm.disabledQRCode = true;
            vm.errorMsgStatus = true;
            setTimeout(() => {
              vm.errorMsgStatus = false;
            }, 2000);
          });
        }
      );
  },
  computed: {
    session() {
        return store.getters.session;
    },
    downloadLink_copy() {
      return store.getters.downloadLink_copy;
    },
    downloadLink_qrcode() {
      return store.getters.downloadLink_qrcode;
    },
    Email() {
      return this.$t("content_message_sent").replace(
        "{EMAIL_ADDRESS}",
        this.email
      );
    }
  },
  mounted() {
    this.genQRCode();
  },
  methods: {
    genQRCode() {
      var canvas = document.getElementById("qr_code");
      QRCode.toCanvas(canvas, this.downloadLink_qrcode, error => {
        if (error) {
          this.disabledQRCode = true;
          this.errorMsgStatus = true;
          setTimeout(() => {
            this.errorMsgStatus = false;
          }, 2000);
        }
      });
    },
    inputSendEmailField() {
      this.sendEmailAction = false;
      this.emailValidation = true;
    },
    recaptchaCallback(recaptchaToken) {
      var send_email_url =
        SEND_EMAIL +
        "?enc_data=" +
        encodeURIComponent(this.$route.query.enc_data) +
        "&pid=" +
        this.$route.query.pid +
        "&session=" + this.session;
      axios
        .post(send_email_url, {
          email: this.email,
          token: recaptchaToken
        })
        .then(res => {
          if (res.data.returnCode === 200) {
            if (this.sendEmailActive) {
              this.step = "sentMail";
            }
            //Enable following code when need to screenshot
            // this.errorMsgStatus = true;
            // setTimeout(() => {
            //   this.errorMsgStatus = false;
            // }, 2000);
          } else {
            this.errorMsgStatus = true;
            setTimeout(() => {
              this.errorMsgStatus = false;
            }, 2000);
          }
          this.sendEmailAction = true;
        })
        .catch(error => {
          this.errorMsgStatus = true;
          setTimeout(() => {
            this.errorMsgStatus = false;
          }, 2000);
          this.sendEmailAction = true;
        });
    },
    clickSendEmail() {
      this.sendEmailActive = !this.sendEmailActive;
      this.qrCodeActive = false;
      this.copyLinkActive = false;
      this.email = "";
      if (this.sendEmailActive) {
        this.step = "inputMail";
      } else {
        this.step = "";
        this.resetTabStatus();
      }
    },
    clickCopyLink() {
      this.copyLinkActive = !this.copyLinkActive;
      this.qrCodeActive = false;
      this.sendEmailActive = false;
      this.resetTabStatus();
    },
    clickQrCode() {
      this.qrCodeActive = !this.qrCodeActive;
      this.sendEmailActive = false;
      this.copyLinkActive = false;
      this.resetTabStatus();
    },
    resetTabStatus() {
      this.sendEmailAction = true;
      this.emailValidation = true;
      this.step = "";
      this.email = "";
    },
    send() {
      this.sendEmailAction = true;
      if (this.email) {
        this.email = this.email.trim();
        if (this.email.search(EMAIL_REGEX) == -1) {
          this.emailValidation = false;
          this.sendEmailAction = false;
        } else {
          this.emailValidation = true;
          this.$refs.invisibleRecaptcha.execute();
        }
      } else {
        this.emailValidation = false;
        this.sendEmailAction = false;
      }
    },
    onCopy(e) {
      this.copyMsgStatus = true;
      setTimeout(() => {
        this.copyMsgStatus = false;
      }, 2000);
    },
    onError: function(e) {
      this.errorMsgStatus = true;
      setTimeout(() => {
        this.errorMsgStatus = false;
      }, 2000);
    }
  }
};
</script>
<style   src="@/../node_modules/bulma/css/bulma.min.css">
</style>
<style   scoped lang="scss" rel="stylesheet/scss" src="@/assets/style/main.scss">
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/index/Mobile_PAD.vue